var v65 = {
	global : {
		init : function(){
			v65.global.addButtonListener();
			v65.global.addToCartListener();
			v65.global.continueShopping();
			v65.global.mainMenuHover();
			v65.global.searchBar();
			v65.global.mobileMenu();
		},
		addButtonListener : function(){
			if(document.addEventListener){
				document.addEventListener("touchstart", function(){}, true);
			}
		},
		addToCartListener : function(){
			$("[v65js=addToCart]").on("submit",function(){
				v65.cookies.createCookie("continueShoppingURL", window.location.href);
			});
		},
		continueShopping : function(){
			if(v65.cookies.readCookie("continueShoppingURL") !== null){
				$(".v65-cartCheckOutButtons a.linkAltBtn, #v65-checkCartSummaryMoreOptions a:contains('Continue shopping')").attr("href", v65.cookies.readCookie("continueShoppingURL"));
			}
		},
		mainMenuHover : function(){
			$(".mainMenu ul li ul li").hover(function(){
				$(this).parent().parent().children("a").toggleClass("hover");
			});
		},
		searchBar : function(){
			// Open and Close
			$('.icon-search').click(function(){
				if($('.headerSearch').hasClass('searchOpen')){
					$('.headerSearch').removeClass('searchOpen');
				}else{
					$('.headerSearch').addClass('searchOpen');
				}
			})

			$('.headerSearch .icon-cross').click(function(){
				$('.headerSearch').removeClass('searchOpen');
			})

			$('html').click(function(){
			     $('.headerSearch').removeClass('searchOpen');
			})

			$('.headerSearch, .icon-search').click(function(e){
			      e.stopPropagation();
			})

			// Search field styling
			$('#v65-contentSearchButton button').addClass('searchFieldButton');
			$('.searchFieldButton span').addClass('icon-search');
			$('#v65-contentSearchInput input').attr('placeholder', 'Search...')

		},
		mobileMenu : function(){
			$(".icon-menu").click(function(){
				$('body').toggleClass('mobileBody');
				$('.mainMenu').toggleClass('menuOpen');
				return false;
			});

			// Close cart when opening menu
			$(".icon-menu").click(function(){
				if(!$('.mainMenu').hasClass('menuOpen') && $('#v65-modalCartDropdown:visible')){
			  		vin65.cart.hideCart();
				}
			});

			// Close menu when opening cart
			$('body').click(function(e){
				if($(e.target).attr('id') === "v65-toggleModalCart"){
			   		if($('.mainMenu').hasClass('menuOpen')){
			  			$('body').toggleClass('mobileBody');
			    		$('.mainMenu').removeClass('menuOpen');
					}
				}
			});
		}
	},
	cookies : {
		createCookie : function(name,value,days) {
			var expires = "";

			if (days) {
				var date = new Date();
				date.setTime(date.getTime()+(days*24*60*60*1000));
				expires = "; expires="+date.toGMTString();
			}

			document.cookie = name+"="+value+expires+"; path=/";
		},
		readCookie : function(name) {
			var nameEQ = name + "=";
			var ca = document.cookie.split(';');
			for(var i=0;i < ca.length;i++) {
				var c = ca[i];
				while (c.charAt(0)==' ') c = c.substring(1,c.length);
				if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
			}
			return null;
		},
		eraseCookie : function(name) {
			createCookie(name,"",-1);
		}
	},
	home : {
    init: function() {
      v65.home.instagramFeed();
    },
    instagramFeed: function(){
      if( !$('#instafeed').length ){ return; }
      var feed = new Instafeed({
        accessToken: '2940733915.0b4bf93.c078efb88dc4456daa40b5c6bf7520c2',
        get: 'user',
        userId: '2940733915',
        limit: 4,
        resolution: 'standard_resolution',
        template: '<a href="{{link}}" target="_blank" style="background-image:url({{image}})"><div class="instagram-content"><span class="instagram__like-count">{{likes}}</span><span class="instagram__comment-count">{{comments}}</span><p class="instagram_caption">{{caption}}</p></div></a>',
      });

      feed.run();
    }
	},
	page : {
		init : function(){
			v65.page.initPhotoGallery();
			v65.page.scrollToBottom();
			v65.page.scrollToTop();
			v65.page.clubStyling();
			v65.page.staffWrapper();
		},
		initPhotoGallery : function(){
			if($("#pagePhotoGallery").length){
        $("div[v65jsphotogalleryid]").each(function(){
          $(this).v65PhotoGallery();
        });
			}
		},
		scrollToBottom : function(){
			$('.footerMenuLink').click(function() {
				$("html, body").animate({ scrollTop: ($("a[name='footerMenu']").offset().top - 20) }, 400);
				return false;
			});
		},
		scrollToTop : function(){
			$(window).scroll(function() {
				if($(document).scrollTop() > 150 && $(window).width() < 580){
					$(".backToTop").css("display", "block");
					$('.v65-productAddToCart-drilldown').addClass('v65-productAddToCart-drilldownActivate');
					$("footer").css("margin-bottom", $('.v65-productAddToCart-drilldownActivate').outerHeight())

				} else{
					$(".backToTop").css("display", "none");
					$('.v65-productAddToCart-drilldown').removeClass('v65-productAddToCart-drilldownActivate');
					$("footer").removeAttr('style');
				}
			});

			$('.backToTop').click(function() {
				$("html, body").animate({ scrollTop: 0 }, 400);
				return false;
			});
		},
		clubStyling : function(){
			// Club signup header
			$('.v65-clubSignUp-Teaser').siblings('h1').addClass('clubSignupTitle');
		},
    staffWrapper: function() {
      $(".person").wrapAll('<section class="staff"></section>');
    }
	},
  products: {
    init: function() {
      v65.products.removeCents();
      v65.products.wrapTitleVintage();
    },
    removeCents: function() {
      var productPrices = $('.v65-product-addToCart-price');
      if (!productPrices.length) {
        return false;
      }

      productPrices.each(function(){
        var matches = $(this).text().match(/(\$\d+)\.0{2}/)
        if(!matches.length) {
          return false;
        }

        $(this).text(matches[1]);
      });
    },
    wrapTitleVintage: function(){
      var productTitles = $('.v65-product-title a,.v65-product-rightCol h1');
      if (!productTitles.length) {
        return false;
      }

      productTitles.each(function(){
        var matches = $(this).text().match(/(\d{4})(.*)/)
        if(!matches.length) {
          return false;
        }

        $(this).html('<span class="product-vintage">' + matches[1] + '</span><span class="product-title">' + matches[2] + '</span>');
      });
    }
  },
	documentReady : {
		init: function(){
			v65.documentReady.headerContent();
		},
		headerContent : function(){
			// Remove empty titles
			$('.pageTitle h1').each(function(){
				if(($(this).text() === "PageTitle")){
			      $(this).text('');
			      $('body').css('position', 'static');
			   }
			});

		}
	}
}

;(function($,undefined){
  $.fn.v65PhotoGallery = function(options){
    var defaults = {
      galleryId : $(this).attr("v65jsphotogalleryid"),
      galleryHeight : $(this).attr("v65jsphotogalleryheight"),
      galleryWidth : $(this).attr("v65jsphotogallerywidth"),
      timestamp : "&timestamp="+ new Date().getTime(),
      effect:'fade', // Specify sets like: 'fold,fade,sliceDown'
      slices:15, // For slice animations
      animSpeed:500, // Slide transition speed
      pauseTime:5000, // How long each slide will show
      startSlide:0, // Set starting Slide (0 index)
      directionNav:true, // Next & Prev navigation
      directionNavHide:true, // Only show on hover
      controlNav:true // 1,2,3... navigation
    },
    gallery = $(this),
    settings = $.extend(defaults, options);
    gallery.html("").css({
      "height":settings.galleryHeight,
      "width":settings.galleryWidth
    });

    if(!settings.galleryId){
      return false;
    }

    gallery.html("");
    $.ajax({
      type: "GET",
      url: "/index.cfm?method=pages.showPhotoGalleryXML&photogalleryid="+settings.galleryId+defaults.timestamp,
      dataType: "xml",
      success: function(xml) {
        var images = "";
        $(xml).find('img').each(function(index) {
          var basePath = '/assets/images/photogallery/images',
          largePath = basePath + '/large/',
          link = $(this).attr('link'),
          photo = $(this).attr('src'),
          title = $(this).attr('title'),
          image = '<img src="'+largePath+photo+'" />';

          if(link){
            images += '<a href="'+link+'">' + image + '</a>';
          } else {
            images += image;
          }
        });
        gallery.append(images);
      },
      complete: function(){
        gallery.nivoSlider({
          effect:settings.effect,
          slices:settings.slices,
          animSpeed:settings.animSpeed,
          pauseTime:settings.pauseTime,
          startSlide:settings.startSlide,
          directionNav:settings.directionNav,
          directionNavHide:settings.directionNavHide,
          controlNav:settings.controlNav
        });
      }
    });
  };
})(jQuery);

v65.global.init();
v65.home.init();
v65.page.init();
v65.products.init();
